// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"RobotoSlab,sans-serif","openNavIcon":"#0073cf"};